import { css } from '@emotion/react'
import {
  Spacing,
  Shadow,
  ShadowElevation,
  CornerRadius,
  gemVar,
  ThemedColors,
  Typography,
} from '@opallabs/gem'

const HEADER_BUTTON_WIDTH = 26
export const ITEM_HEIGHT = 32

export const SEARCH_ID = 'cascading-menu-search-item'

const rootClass = 'lapidary-cascading-menu'
export const selectors = {
  root: rootClass,
} as const

export const container = css({
  ...Shadow[ShadowElevation.E2],
  backgroundColor: gemVar(ThemedColors.Surface1),
  borderRadius: CornerRadius.Large,
  display: 'flex',
  flexDirection: 'column',
  inlineSize: '100%',
  maxBlockSize: 400,
  padding: Spacing.XS,
})

export const headerItem = css({
  alignItems: 'center',
  display: 'flex',
  gap: Spacing.XS,
  marginBlockEnd: Spacing.XS,
  minBlockSize: ITEM_HEIGHT,
  textAlign: 'center',
})

export const headerItemText = css({
  ...Typography.H50,
  flex: '1 0 auto',
  inlineSize: `calc(100% - ${HEADER_BUTTON_WIDTH}px)`,
  overflow: 'hidden',
  paddingInline: Spacing.XS,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  // When preceded by a back button, add invisible spacer to keep visually centered
  'button + &:after': {
    content: "''",
    display: 'inline-block',
    maxInlineSize: HEADER_BUTTON_WIDTH + Spacing.XS, // button width + gap
  },
})

export const search = css({
  borderRadius: CornerRadius.Small,
})
